import * as TYPE from '../types';
const initialState = {
  data: {},
};
export const paymentInterfaceReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case TYPE.PAYMENT_INTERFACE_DATA_FOUND:
      return {
        ...state,
        data: action.payload.data,
      };
    case TYPE.PAYMENT_INTERFACE_DATA_ERROR:
      return {
        ...state,
        data: {},
      };
    default:
      return state;
  }
};
